/**
 * Reserved partition key for platform-tenancy system agents (D-034 / D-042).
 * Prefixed so it cannot collide with a real organization id, and chosen to be a
 * legal Firestore document id (must not match `__.*__`).
 * This is the only file that may contain the `@platform` literal.
 */
export const PLATFORM_TENANT_KEY = '@platform' as const;

export type PlatformTenantKey = typeof PLATFORM_TENANT_KEY;

export type IsPlatformTenantKeyParams = {
    value: string;
};

export type AssertNotPlatformTenantKeyParams = {
    value: string;
};
